import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import service from '@services/passenger-bus'

export const fetchOperators = createAsyncThunk('operators/fetchOperators', async (params, { rejectWithValue }) => {
  try {
    const res = await service.getOperators(params)
    return { params, data: res.data, meta: res.meta }
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message)
  }
})

export const fetchOperator = createAsyncThunk('operators/fetchOperator', async (id, { rejectWithValue }) => {
  try { return await service.getOperator(id) } catch (err) { return rejectWithValue(err.response?.data || err.message) }
})

export const addOperator = createAsyncThunk('operators/addOperator', async (payload, { rejectWithValue }) => {
  try { return await service.addOperator(payload) } catch (err) { return rejectWithValue(err.response?.data || err.message) }
})

export const saveOperator = createAsyncThunk('operators/saveOperator', async (payload, { rejectWithValue }) => {
  try { return await service.updateOperator(payload) } catch (err) { return rejectWithValue(err.response?.data || err.message) }
})

export const removeOperator = createAsyncThunk('operators/removeOperator', async (id, { rejectWithValue }) => {
  try { await service.deleteOperator(id); return id } catch (err) { return rejectWithValue(err.response?.data || err.message) }
})

const slice = createSlice({
  name: 'operators',
  initialState: { data: [], meta: null, params: { page: 1, take: 10, order: 'ASC', q: '' }, selected: null, loading: false, error: null },
  reducers: { setOperatorParams(state, action) { state.params = action.payload } },
  extraReducers: builder => {
    builder
      .addCase(fetchOperators.pending, s => { s.loading = true })
      .addCase(fetchOperators.fulfilled, (s, a) => { s.loading = false; s.data = a.payload.data; s.meta = a.payload.meta; s.params = a.payload.params })
      .addCase(fetchOperators.rejected, (s, a) => { s.loading = false; s.error = a.payload })
      .addCase(fetchOperator.pending, s => { s.loading = true })
      .addCase(fetchOperator.fulfilled, (s, a) => { s.loading = false; s.selected = a.payload })
      .addCase(fetchOperator.rejected, (s, a) => { s.loading = false; s.error = a.payload })
      .addCase(addOperator.fulfilled, (s, a) => { s.data.unshift(a.payload) })
      .addCase(saveOperator.fulfilled, (s, a) => { const i = s.data.findIndex(x => x.id === a.payload.id); if (i > -1) s.data[i] = a.payload })
      .addCase(removeOperator.fulfilled, (s, a) => { s.data = s.data.filter(x => x.id !== a.payload) })
  }
})

export const { setOperatorParams } = slice.actions
export default slice.reducer
